import { render, staticRenderFns } from "./jiti.vue?vue&type=template&id=427a470a&scoped=true"
import script from "./jiti.vue?vue&type=script&lang=js"
export * from "./jiti.vue?vue&type=script&lang=js"
import style0 from "./jiti.vue?vue&type=style&index=0&id=427a470a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a470a",
  null
  
)

export default component.exports